window.addEventListener('DOMContentLoaded', function() {
  /**
   * 点击购买打开变体弹窗
   */
  const buyFormDoms = document.querySelectorAll('[data-hs-buy]')
  if (buyFormDoms.length > 0) {
    buyFormDoms.forEach(function(item) {
      document.dispatchEvent(new CustomEvent('hs:prod:card:buy', { detail: { data: item } }))
    })
  }
  const buyNowBtnDoms = document.querySelectorAll('[data-hs-buynow-button]')
  if (buyNowBtnDoms.length > 0) {
    buyNowBtnDoms.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        const form = item.closest('[data-hs-buy]')
        if (!form) return;
        document.dispatchEvent(new CustomEvent('hs:prod:buy:now:click', { detail: { buyNowBtn: item, form } }))
      })
    })
  }
  
  // 初始化倒计时
  document.querySelectorAll('[data-hs-cd-timer]').forEach(function (container) {
    var timerEl = container
    if (!timerEl) return;

    var endTimeStr = timerEl.getAttribute('data-end-time');
    var startTimeStr = timerEl.getAttribute('data-start-time'); // 【新增】获取开始时间
    var shopOffsetStr = timerEl.getAttribute('data-shop-offset');

    if (!endTimeStr || !shopOffsetStr) return;

    // --- 辅助函数：解析时区偏移量字符串 (例如 "+0800" 或 "-0400") ---
    function parseOffsetToMinutes(offsetStr) {
      if (!offsetStr || offsetStr.length < 5) return 0;
      var sign = offsetStr[0] === '-' ? -1 : 1;
      var hours = parseInt(offsetStr.slice(1, 3), 10);
      var minutes = parseInt(offsetStr.slice(3, 5), 10);
      if (isNaN(hours) || isNaN(minutes)) return 0;
      return sign * (hours * 60 + minutes);
    }

    var shopOffsetMinutes = parseOffsetToMinutes(shopOffsetStr);

    // --- 辅助函数：将【带时区偏移的本地时间】转换为【绝对 UTC 时间戳】 ---
    function parseShopLocalTimeToUTC(timeStr, offsetMinutes) {
      if (!timeStr) return NaN;
      timeStr = timeStr.replace('T', ' ').trim();
      var parts = timeStr.split(' ');
      if (parts.length < 2) return NaN;

      var dateBits = parts[0].split('-');
      if (dateBits.length !== 3) return NaN;

      var year = parseInt(dateBits[0], 10);
      var month = parseInt(dateBits[1], 10);
      var day = parseInt(dateBits[2], 10);

      var timeBits = parts[1].split(':');
      var hour = parseInt(timeBits[0], 10);
      var minute = parseInt(timeBits[1] || '0', 10);
      var second = parseInt(timeBits[2] || '0', 10);

      if ([year, month, day, hour, minute, second].some(isNaN)) return NaN;

      // 核心算法：先按 UTC 算出毫秒数，然后【减去】时区偏移量，得到真实的 UTC 时间戳
      var localMillis = Date.UTC(year, month - 1, day, hour, minute, second);
      return localMillis - offsetMinutes * 60 * 1000;
    }

    // 1. 解析结束时间，如果解析失败直接退出
    var endUTC = parseShopLocalTimeToUTC(endTimeStr, shopOffsetMinutes);
    if (isNaN(endUTC)) return;

    // 2. 【新增】解析开始时间，如果没传或解析失败，返回 NaN
    var startUTC = parseShopLocalTimeToUTC(startTimeStr, shopOffsetMinutes);

    // --- 获取 DOM 节点 ---
    var daysEl = timerEl.querySelector('.js-countdown-days');
    var hoursEl = timerEl.querySelector('.js-countdown-hours');
    var minutesEl = timerEl.querySelector('.js-countdown-minutes');
    var secondsEl = timerEl.querySelector('.js-countdown-seconds');
    var endedMessageEl = container.querySelector('.js-countdown-ended');

    function pad(num) {
      return num < 10 ? '0' + num : String(num);
    }

    function updateCountdown() {
      // 获取当前的绝对 UTC 时间戳
      var nowUTC = Date.now();

      // 【核心对比逻辑】：
      // 只有当 startUTC 是有效数字，且 当前时间 < 开始时间 时，才隐藏
      if (!isNaN(startUTC) && nowUTC < startUTC) {
        container.style.display = 'none'; 
        return; 
      } else {
        container.style.display = ''; 
      }

      // 到达开始时间，或没有配置开始时间，确保容器显示
      container.style.display = ''; 

      // 计算距离结束时间的差值
      var distance = endUTC - nowUTC;

      // 结束后的逻辑
      if (distance <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';

        timerEl.style.opacity = '0.5';
        if (endedMessageEl) endedMessageEl.style.display = 'block';

        clearInterval(intervalId);
        return;
      }

      // 正常倒计时计算
      var totalSeconds = Math.floor(distance / 1000);
      var days = Math.floor(totalSeconds / 86400);
      totalSeconds -= days * 86400;

      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds -= hours * 3600;

      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds - minutes * 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    var intervalId = setInterval(updateCountdown, 1000);
  });
})



class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.hs-ps__predresult');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const q = encodeURIComponent(searchTerm.trim());
    fetch(`/search/suggest?q=${q}&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((res) => {
            var error = new Error(res.message || 'Search request failed');
            this.close();
            throw error;
          });
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        document.dispatchEvent(new CustomEvent('fetch:api:error', { detail: error }));
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.dispatchEvent(new CustomEvent('pred-search-has-value', { bubbles: true }));
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.dispatchEvent(new CustomEvent('pred-search-is-empty', { bubbles: true }));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);



